type IconProps = { size?: number };

const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function DashboardIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
      <rect x="2.5" y="2.5" width="6.5" height="6.5" rx="1.3" />
      <rect x="11" y="2.5" width="6.5" height="4" rx="1.3" />
      <rect x="11" y="8.5" width="6.5" height="9" rx="1.3" />
      <rect x="2.5" y="11" width="6.5" height="6.5" rx="1.3" />
    </svg>
  );
}

export function ServersIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
      <rect x="2.5" y="3" width="15" height="5" rx="1.4" />
      <rect x="2.5" y="12" width="15" height="5" rx="1.4" />
      <circle cx="6" cy="5.5" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="6" cy="14.5" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function GeneratorIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
      <path d="M10 2.5 3 11h5.5L9 17.5 17 8.5h-5.5L10 2.5Z" />
    </svg>
  );
}

export function LogsIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
      <rect x="3" y="2.5" width="14" height="15" rx="1.4" />
      <path d="M6.5 7h7M6.5 10.3h7M6.5 13.6h4.5" />
    </svg>
  );
}

export function SettingsIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
      <circle cx="10" cy="10" r="2.6" />
      <path d="M10 2.8v2.1M10 15.1v2.1M17.2 10h-2.1M4.9 10H2.8M15.1 4.9l-1.5 1.5M6.4 13.6l-1.5 1.5M15.1 15.1l-1.5-1.5M6.4 6.4 4.9 4.9" />
    </svg>
  );
}

export function PlayersIcon({ size = 28 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" {...base}>
      <circle cx="12.5" cy="11" r="3.6" />
      <path d="M5.5 24c0-4.1 3.1-7 7-7s7 2.9 7 7" />
      <circle cx="22" cy="12.5" r="2.8" />
      <path d="M20.5 17.3c3.2.4 5.5 2.9 5.5 6.2" />
    </svg>
  );
}

export function ChatIcon({ size = 28 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" {...base}>
      <path d="M6 8.5h20a1.6 1.6 0 0 1 1.6 1.6v9.4a1.6 1.6 0 0 1-1.6 1.6H14l-5 4v-4H6a1.6 1.6 0 0 1-1.6-1.6v-9.4A1.6 1.6 0 0 1 6 8.5Z" />
      <path d="M10.5 14h11M10.5 17.5h7" />
    </svg>
  );
}

export function HelperIcon({ size = 28 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" {...base}>
      <path d="M16 5.5 18 12l6.5 2-6.5 2-2 6.5-2-6.5L7.5 14l6.5-2 2-6.5Z" />
    </svg>
  );
}

export function StatusIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
      <path d="M2.5 11h3l2-6 4 11 2-7 1.5 2h2.5" />
    </svg>
  );
}
